import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const creditTermsAdapter = getAdapter();

const creditTermsSlice = createSlice({
  name: 'creditTerms',
  initialState: creditTermsAdapter.getInitialState(),
  reducers: {
    setCreditTerms: (state, { payload: { creditTerms } }) => {
      creditTermsAdapter.setAll(state, creditTerms);
    },
  },
});

const selectors = creditTermsAdapter.getSelectors(({ creditTerms }) => creditTerms);

export const getCreditTerms = (state) => selectors.selectAll(state);

export const {
   setCreditTerms,
} = creditTermsSlice.actions;

export default creditTermsSlice.reducer;